<script>
  import { onMount, onDestroy } from "svelte";
  // import { currentUser } from './stores/user.js';
  import { db } from "./firestore";
  import { userData } from "./stores/userStore.js";

  let userListener;
  let authStateChangedListener;

  onMount(() => {
    authStateChangedListener = firebase
      .auth()
      .onAuthStateChanged(async function (user) {
        if (user) {
          // User is already signed in / known
          console.log("Known user", user.uid);
          //TODO filter getitout app users
          var docRef = db.collection("sneak-peek-users").doc(user.uid);

          docRef
            .get()
            .then(function (doc) {
              if (doc.exists) {
                console.log("Document data:", doc.data());
                userData.setData({
                  user: user,
                  doc: doc.data(),
                });
              } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
              }
            })
            .catch(function (error) {
              console.log("Error getting document:", error);
            });
        } else {
          // User is signed out or doesn't exist
          console.log("Unkonwn user");
          //signIn();
        }
      });
  });

  onDestroy(() => {
    authStateChangedListener();
  });
</script>
